import { MenuItemLink, useSidebarState } from 'react-admin';
import { Box, Typography } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import PublicIcon from '@mui/icons-material/Public';
import HistoryIcon from '@mui/icons-material/History';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import SmsIcon from '@mui/icons-material/Sms';
import WebhookIcon from '@mui/icons-material/Webhook';
import SettingsIcon from '@mui/icons-material/Settings';
import StarIcon from '@mui/icons-material/Star';
import BlockIcon from '@mui/icons-material/Block';

export const CustomMenu = () => {
  const [open] = useSidebarState();

  return (
    <Box
      sx={{
        width: open ? 260 : 55,
        minHeight: '100vh',
        transition: 'width 0.3s',
        overflowX: 'hidden',
        backgroundColor: '#283046',
      }}
    >
      {/* Logo Section */}
      <Box
        sx={{
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          borderBottom: '1px solid #404656',
        }}
      >
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #7367f0 0%, #ce9ffc 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(115, 103, 240, 0.4)',
          }}
        >
          <SmsIcon sx={{ color: 'white', fontSize: 22 }} />
        </Box>
        {open && (
          <Box>
            <Typography
              variant="h6"
              sx={{
                color: '#d0d2d6',
                fontWeight: 700,
                fontSize: '1.1rem',
                lineHeight: 1.2,
              }}
            >
              SMS Hero
            </Typography>
            <Typography
              variant="caption"
              sx={{ color: '#676d7d', fontSize: '0.7rem' }}
            >
              Admin Panel
            </Typography>
          </Box>
        )}
      </Box>

      {/* Menu Items */}
      <Box sx={{ py: 2 }}>
        {open && (
          <Typography
            variant="overline"
            sx={{
              color: '#676d7d',
              px: 2.5,
              fontSize: '0.65rem',
              letterSpacing: '0.1em',
              display: 'block',
              mb: 1,
            }}
          >
            Dashboard
          </Typography>
        )}

        <MenuItemLink
          to="/"
          primaryText={open ? 'Ana Sayfa' : ''}
          leftIcon={<DashboardIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        {open && (
          <>
            <Typography
              variant="overline"
              sx={{
                color: '#676d7d',
                px: 2.5,
                fontSize: '0.65rem',
                letterSpacing: '0.1em',
                display: 'block',
                mt: 2.5,
                mb: 1,
              }}
            >
              Kullanıcılar
            </Typography>
          </>
        )}

        <MenuItemLink
          to="/users"
          primaryText={open ? 'Kullanıcı Listesi' : ''}
          leftIcon={<PeopleIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        {open && (
          <>
            <Typography
              variant="overline"
              sx={{
                color: '#676d7d',
                px: 2.5,
                fontSize: '0.65rem',
                letterSpacing: '0.1em',
                display: 'block',
                mt: 2.5,
                mb: 1,
              }}
            >
              SMS Yönetimi
            </Typography>
          </>
        )}

        <MenuItemLink
          to="/admin/sms/services"
          primaryText={open ? 'Servisler' : ''}
          leftIcon={<PhoneAndroidIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/admin/sms/countries"
          primaryText={open ? 'Ülkeler' : ''}
          leftIcon={<PublicIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/admin/sms/activations"
          primaryText={open ? 'Aktivasyonlar' : ''}
          leftIcon={<ConfirmationNumberIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/admin/sms/history"
          primaryText={open ? 'Geçmiş' : ''}
          leftIcon={<HistoryIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/admin/sms/webhook-logs"
          primaryText={open ? 'Webhook Logları' : ''}
          leftIcon={<WebhookIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        {open && (
          <>
            <Typography
              variant="overline"
              sx={{
                color: '#676d7d',
                px: 2.5,
                fontSize: '0.65rem',
                letterSpacing: '0.1em',
                display: 'block',
                mt: 2.5,
                mb: 1,
              }}
            >
              Ayarlar
            </Typography>
          </>
        )}

        <MenuItemLink
          to="/popular-services"
          primaryText={open ? 'Popüler Servisler' : ''}
          leftIcon={<StarIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/excluded-services"
          primaryText={open ? 'Hariç Servisler' : ''}
          leftIcon={<BlockIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/excluded-countries"
          primaryText={open ? 'Hariç Ülkeler' : ''}
          leftIcon={<BlockIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />

        <MenuItemLink
          to="/settings"
          primaryText={open ? 'Coin Ayarları' : ''}
          leftIcon={<SettingsIcon />}
          sx={{
            color: '#d0d2d6',
            mx: 1.5,
            borderRadius: '8px',
            '& .MuiSvgIcon-root': { color: '#676d7d' },
            '&.RaMenuItemLink-active': {
              backgroundColor: 'rgba(115, 103, 240, 0.16)',
              color: '#7367f0',
              '& .MuiSvgIcon-root': { color: '#7367f0' },
            },
            '&:hover': {
              backgroundColor: 'rgba(115, 103, 240, 0.08)',
            },
          }}
        />
      </Box>
    </Box>
  );
};
